<ng-container *transloco="let t">
  <label [for]="formControlName"
    >{{ label }}
    <ng-container *ngIf="required"><span [class.required-color]="requiredColor">*</span></ng-container>
    <ng-container *ngIf="parentVisible"
      >&nbsp;<i [class]="iconService.eye" placement="top" [ngbTooltip]="t('child/parentInfo')"></i
    ></ng-container>
  </label>
  <div class="input-group">
    <input
      [id]="formControlName"
      (click)="dp.toggle()"
      class="form-control form-control-lg form-control-append"
      [placeholder]="placeholder && placeholder"
      [formControl]="getFormControl()"
      [minDate]="minDate"
      [maxDate]="maxDate"
      ngbDatepicker
      #dp="ngbDatepicker"
      type="text"
      [ngClass]="{
        'is-invalid':
          childForm.get(formControlName).invalid && (childForm.get(formControlName).dirty || childForm.get(formControlName).touched)
      }"
    />
    <i class="append-icon material-symbols-rounded append-icon-lg" (click)="dp.toggle()">calendar_month </i>
    <ng-container>
      <div
        *ngIf="childForm.get(formControlName).invalid && (childForm.get(formControlName).dirty || childForm.get(formControlName).touched)"
        class="invalid-feedback"
      >
        <div *ngIf="required && childForm.get(formControlName).errors.required">{{ formControlError }}</div>
        <div *ngIf="childForm.get(formControlName).errors.ngbDate?.invalid">{{ t('child/invalidDate') }}</div>
      </div>
    </ng-container>
  </div>
</ng-container>
